'use client';

import React from 'react';
import * as StyledComponents from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName, target) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}

interface StyleSheetManagerI {
  children: any;
  sheet?: StyledComponents.ServerStyleSheet;
}

export const StyleSheetManager: React.FC<StyleSheetManagerI> = ({ children, sheet }) => {
  return (
    <StyledComponents.StyleSheetManager sheet={sheet?.instance} shouldForwardProp={shouldForwardProp}>
      {children}
    </StyledComponents.StyleSheetManager>
  );
};
